import { Injectable, ElementRef } from '@angular/core';
export class SidebarRightService {
public elementRef: ElementRef;
/**
 * [offsetHeight description]
 * \@method offsetHeight
 * @return {?}
 */
get offsetHeight(): number {
    return this.elementRef ? this.elementRef.nativeElement.offsetHeight: null;
  }
/**
 * [scrollHeight description]
 * \@method scrollHeight
 * @return {?}
 */
get scrollHeight(): number {
    return this.elementRef ? this.elementRef.nativeElement.scrollHeight: null;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SidebarRightService_tsickle_Closure_declarations() {
/** @type {?} */
SidebarRightService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarRightService.ctorParameters;
/** @type {?} */
SidebarRightService.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
